/*
  *** Promotions ***
  - Promotions rely on the data-promotions-config JSON config, wihch is outputted via Liquid
*/

const promotionsConfig = document.querySelector(
    '[data-promotions-config]',
  )?.innerHTML,
  promotions = promotionsConfig ? JSON.parse(promotionsConfig) : [];

const updateCartDrawer = async () => {
  /* eslint-disable */
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    /* eslint-enable */
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      let selectors = [
        'cart-drawer-items',
        '.cart-drawer-samples',
        '.drawer__footer',
      ];
      let cartIsEmpty = html
        .querySelector('cart-drawer')
        .classList.contains('is-empty');

      if (cartIsEmpty) {
        const targetCartDrawer = document.querySelector('cart-drawer');
        targetCartDrawer?.classList.add('is-empty');
        selectors = ['.drawer__inner'];
      }

      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (typeof targetElement?.checkSamplesCallback === 'function') {
          targetElement.checkSamplesCallback();
        }
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      const wrapper = document.querySelector(
        '.cart-drawer.accordions--initialized',
      );
      if (wrapper) {
        wrapper.classList.remove('accordions--initialized');
        document.dispatchEvent(new Event('cartContentUpdated'));
      }
      // eslint-disable-next-line no-undef
      initCartSpliders();
    });
};

const getTotalWithoutGifts = (lines) => {
  return (lines?.reduce((acc, line) => {
    let linePrice = line.final_line_price;
    const giftProperties = ['_gift', '_bxgy_gift', '_bogo'] //@todo refactor - add line prop key names to promotion objects
    const hasGiftProp = giftProperties.some(propName => line.properties[propName]);

    if (hasGiftProp) {
      linePrice = 0
    }
    return acc + linePrice
  }, 0) / 100);
}

const removeGiftItems = async (giftKeys) => {
  let itemsToRemove = {};

  giftKeys.forEach(key => {
    itemsToRemove[key] = 0;
  });

  try {
    /* eslint-disable */
    await fetch(`${routes.cart_update_url}.js`, {
      /* eslint-enable */
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates: itemsToRemove })
    });
    await updateCartDrawer();
  } catch (error) {
    console.error('Error:', error);
  }
};

const addGiftItems = async (itemsToAdd) => {
  try {
    /* eslint-disable */
    await fetch(`${routes.cart_add_url}.js`, {
      /* eslint-enable */
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: itemsToAdd
      })
    });
    await updateCartDrawer();
  } catch (error) {
    console.error('Error:', error);
  }
};

/* Determine if promotion meets cart criteria */
const evaluatePromotion = async (promotion) => {
  let itemsAddQueue = [];
  let itemsRemoveQueue = [];

  /* eslint-disable */
  const cartResponse = await fetch(`${routes.cart_url}.js`).then((response) =>
    response.json(),
  );
  /* eslint-enable */
  const items = cartResponse.items;

  // Prevent further auto-add for manually removed line items
  let manuallyRemovedItems = sessionStorage.getItem('fab_removed_gifts');
  let removedItemsArr = [];
  let preventAutoAdd = false;
  if (manuallyRemovedItems) {
    removedItemsArr = JSON.parse(manuallyRemovedItems);
    if (removedItemsArr.length) {
      // @todo clean this up.
      if (promotion.type == 'gwp') {
        preventAutoAdd = removedItemsArr.some(
          (storedVariant) => storedVariant == promotion.variant_id,
        );
      }

      if (promotion.type == 'bogo') {
        preventAutoAdd = removedItemsArr.some(
          (storedVariant) => storedVariant == promotion.buy_variant_id,
        );
      }
    }
  }

  switch(promotion.type) {
    case 'gwp': {
      const giftVariant = parseInt(promotion.variant_id);
      const itemSubTotal = getTotalWithoutGifts(items);
      const giftItem = items.find(item => item.variant_id === giftVariant && item.properties?._gift);

      // Add gift item queue
      if (itemSubTotal >= promotion.threshold && !giftItem && !preventAutoAdd) {
        itemsAddQueue.push({
          id: promotion.variant_id,
          quantity: promotion.quantity,
          properties: { '_gift': promotion.promotion_id }
        });
      }

      if (itemSubTotal < promotion.threshold && giftItem) {
        itemsRemoveQueue.push(giftItem.key);
      }

      // Remove expired GWP items
      const invalidGwpItems = items.filter(item => item.variant_id !== giftVariant && item.properties?._gift);
      if (invalidGwpItems.length) {
        await invalidGwpItems.forEach(item => {
          itemsRemoveQueue.push(item.key);
        });
      }
      break;
    }
    case 'bogo': {
      const buyVariant = parseInt(promotion.buy_variant_id);
      const getVariant = parseInt(promotion.get_variant_id);
      const buyQuantity = parseInt(promotion.buy_quantity);
      const buyItem = items.find(item => item.variant_id === buyVariant && !item.properties?._bogo);
      const getItem = items.find(item => item.variant_id === getVariant && item.properties?._bogo);
      const isQuantitySufficient = buyItem?.quantity >= buyQuantity;

      // Add gift item to queue
      if (buyItem && !getItem && isQuantitySufficient && !preventAutoAdd) {
        itemsAddQueue.push({
          id: getVariant,
          quantity: promotion.quantity,
          properties: { '_bogo': promotion.promotion_id }
        });
      }

      if ((!buyItem && getItem) || (!isQuantitySufficient && getItem)) {
        itemsRemoveQueue.push(getItem.key);
      }

      // Remove expired BOGO items
      const invalidBogoItems = items.filter(item => item.variant_id !== getVariant && item.properties?._bogo);
      if (invalidBogoItems.length) {
        await invalidBogoItems.forEach(item => {
          itemsRemoveQueue.push(item.key);
        });
      }
      break;
    }
    case 'bxgy': {
      const bxVariants = promotion.buy_x_variants;
      const gyVariants = promotion.get_y_variants;
      const quantityPerGift = parseInt(promotion.quantity_per_gift);
      const bxgyCartThreshold = parseInt(promotion.cart_threshold);
      const bxgyItemSubTotal = getTotalWithoutGifts(items);

      // Check if the cart threshold is satisfied
      const thresholdSatisfied = bxgyItemSubTotal >= bxgyCartThreshold;

      // Check if any qualifying Buy X variant is in the cart.
      const hasAnyQualifyingVariant = bxVariants.some(variant => items.find(item => item.variant_id == variant.id));

      // Filter out gift items that are aleady in the cart
      const giftItemsToAdd = gyVariants.filter(variant => {
        // Do not include items that have been manually removed
        let itemRemovedManually = false;
        if (removedItemsArr.length) {
          itemRemovedManually = removedItemsArr.some((storedVariant) => variant.id == storedVariant);
        }

        const variantIsInCart = items.some(item => item.variant_id == variant.id && item.properties?._bxgy_gift);
        return !variantIsInCart && !itemRemovedManually;
      }).map(variant => variant.id);

      // Add gift items to queue
      if (hasAnyQualifyingVariant && giftItemsToAdd.length && thresholdSatisfied) {
        giftItemsToAdd.forEach(variantId => {
          itemsAddQueue.push({
            id: variantId,
            quantity: quantityPerGift,
            properties: { '_bxgy_gift': promotion.promotion_id }
          });
        })
      }

      if (!hasAnyQualifyingVariant || !thresholdSatisfied) {
        const gifItemsToRemove = items.filter(item => {
          const isGiftItem = item.properties?._bxgy_gift;
          const giftIsInCart = gyVariants.some(variant => variant.id === item.variant_id && isGiftItem);
          return giftIsInCart;
        }).map(item => item.key);

        if (gifItemsToRemove.length) {
          gifItemsToRemove.forEach(item => {
            itemsRemoveQueue.push(item);
          })
        }
      }
    }
  }

  return { itemsAddQueue, itemsRemoveQueue }
}

const runPromotions = async () => {
  let itemsToAdd = [];
  let itemsToRemove = [];

  // Get queued items to add/remove
  for (const promotion of promotions) {
    const { itemsAddQueue, itemsRemoveQueue } = await evaluatePromotion(promotion);

    // Merge add/remove arrays
    if (itemsAddQueue) itemsToAdd.push(...itemsAddQueue);
    if (itemsRemoveQueue) itemsToRemove.push(...itemsRemoveQueue);
  };

  // Add the gift items in a single call
  if (itemsToAdd.length) {
    await addGiftItems(itemsToAdd);
  }

  // Remove the gift items in a single call
  if (itemsToRemove.length) {
    await removeGiftItems(itemsToRemove);
  }
}

/* eslint-disable */
if (promotionsConfig) {
  // Run promotions on cart update
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    runPromotions();
  });

  // Run promotions on page load
  runPromotions();
}
/* eslint-enable */
